import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { NavigatorService } from 'ember-browser-services';

interface Signature {
  Args: {
    isRunning: boolean;
    mimeType: string;
    iframeTitle?: string;
    alternativeText?: string;
    src?: string;
  };
}

export default class FileDownloadAndVisualisation extends Component<Signature> {
  @service('browser/navigator') declare navigator: NavigatorService;

  get fileAttachmentIsAnImage(): boolean {
    return (
      this.args.mimeType.substring(0, this.args.mimeType.indexOf('/')) ===
      'image'
    );
  }

  /**
   * Browsers before Safari 16.4 and Firefox 99 do not define `pdfViewerEnabled`.
   * They keep the iframe.
   */
  get canDisplayPdf(): boolean {
    return this.navigator.pdfViewerEnabled !== false;
  }

  get iframeTitle(): string {
    return this.args.iframeTitle || 'Document';
  }

  <template>
    <div>
      {{#if @isRunning}}
        <div class='ui segment h-28'>
          <div class='ui active inverted dimmer'>
            <div class='ui text loader'>Récupération du document</div>
          </div>
        </div>
      {{else if @src}}
        {{#if this.fileAttachmentIsAnImage}}
          <img
            class='w-full'
            src={{@src}}
            alt={{if @alternativeText @alternativeText ''}}
            data-test-image-file-attachment
          />
        {{else}}
          {{#if this.canDisplayPdf}}
            <iframe
              title={{this.iframeTitle}}
              class='h-[700px] w-full'
              data-test-iframe
              src={{@src}}
              frameborder='0'
              scrolling='auto'
            >
            </iframe>
          {{/if}}
        {{/if}}
      {{else}}
        <div class='ui error message visible'>Une erreur est survenue pendant
          l'affichage du contenu. Essayez de rafraîchir la page.</div>
      {{/if}}
    </div>
  </template>
}
